import { Project } from '../models/project.model';
import { TechnologyExperience } from '../models/technologyExperience.model';
import { BackendHttpService } from './backendHttpService';

export class ProjectService extends BackendHttpService {
  private projectRolesDictionaryCache: string[] | null = null;

  constructor() {
    super('project');
  }

  async getProjectRolesDictionary(): Promise<string[]> {
    if (this.projectRolesDictionaryCache) {
      return this.projectRolesDictionaryCache;
    }
    try {
      this.projectRolesDictionaryCache = await this.get<string[]>('/rolesDictionary');
      return this.projectRolesDictionaryCache;
    } catch (error) {
      console.error('Error getting project roles dictionary:', error);
      throw error;
    }
  }

  async getProjectByPersonID(personId: number): Promise<Project[]> {
    try {
      const projects = await this.get<Project[]>(`/byUserId/${personId}`);
      return projects.map(project => ({
        ...project,
        endDate: project.endDate === null || 
                project.endDate.toString() === '0001-01-01T00:00:00Z' 
                ? null 
                : new Date(project.endDate),
        startDate: new Date(project.startDate)
      }));
    } catch (error) {
      console.error(`Error getting projects for person ${personId}:`, error);
      throw error;
    }
  }

  async addProject(project: Project): Promise<Project> {
    try {
      return await this.post<Project, Project>(project);
    } catch (error) {
      console.error('Error adding project:', error);
      throw error;
    }
  }

  async updateProject(project: Project): Promise<Project> {
    try {
      return await this.put<Project, Project>(project);
    } catch (error) {
      console.error('Error updating project:', error);
      throw error;
    }
  }

  async deleteProject(project: Project): Promise<void> {
    try {
      await this.delete(project.id.toString());
    } catch (error) {
      console.error('Error deleting project:', error);
      throw error;
    }
  }

  async getTechnologyExperienceByPerson(personId: number): Promise<TechnologyExperience[]> {
    try {
      return await this.get<TechnologyExperience[]>(`/byUserId/${personId}/technologyExperience`);
    } catch (error) {
      console.error(`Error getting technology experience for person ${personId}:`, error);
      throw error;
    }
  }
} 
